import { useTranslation } from "@l2r-front/l2r-i18n"

import { I18N_NAMESPACE } from "../../constants/i18n"

import * as Styled from "./StreetView.styled"

export const StreetViewError = () => {

    const { t } = useTranslation(I18N_NAMESPACE)

    return <Styled.ErrorContainer id="google-streetview-error">
        <Styled.ErrorMessage variant="Desktop & Mobile/Body/Small">
            {t(I18N_NAMESPACE, "containers.streetView.error")}
        </Styled.ErrorMessage>
    </Styled.ErrorContainer>
}